/**
 * Purpose:
 *   Renders expandable menu item chevron icon.
 */

import { cx } from '@/util/functions/cx';
import { Icon } from '@/components/ui/icon/Icon';
import {
  MENU_CHEVRON,
  MENU_CHEVRON_COLLAPSED,
  MENU_CHEVRON_EXPANDED,
} from './Menu.styles';

export interface IMenuItemChevronProps {
  expanded: boolean;
  style?: React.CSSProperties;
}

export function MenuItemChevron({ expanded, style }: IMenuItemChevronProps) {
  return (
    <span style={style}>
      <Icon
        src="/icons/chevron-down.svg"
        size={16}
        className={cx(
          MENU_CHEVRON,
          expanded ? MENU_CHEVRON_EXPANDED : MENU_CHEVRON_COLLAPSED
        )}
        aria-hidden
      />
    </span>
  );
}
